import { invoicesConstants } from '../constants';

export function invoicesReducers(state = {}, action) {
    const { 
        totalRequests = 0,
        collectiveErrorMsg = ""
    } = state;

    let collectiveErrorMsg_formatted = collectiveErrorMsg;

    switch (action.type) {
            
        // Get Invoice List
        
        case invoicesConstants.getInvoiceList_request:
            return {
                ...state,
                getInvoiceList_requesting: true, getInvoiceList_status: false,
            }
        case invoicesConstants.getInvoiceList_success:
            return {
                ...state,
                getInvoiceList_requesting: false, getInvoiceList_status: true,
                invoiceList: action.details.data,
                invoiceListHeaders: action.details.headers,
            }
        case invoicesConstants.getInvoiceList_failure:
            return {
                ...state,
                getInvoiceList_requesting: false, getInvoiceList_status: false, 
            }

        // Generate Appendix
        
        case invoicesConstants.generateAppendix_request:
            if (totalRequests == 0) 
                collectiveErrorMsg_formatted = "";

            return {
                ...state,
                generateAppendix_requesting: true, generateAppendix_status: false,
                isInvoiceRecordUpdatedSuccessfully: undefined,
                generateAppendix_errorMsg: undefined,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: (!(action?.details?.isRetrying))? (totalRequests + 1): totalRequests
            }
        case invoicesConstants.generateAppendix_success:
            return {
                ...state,
                generateAppendix_requesting: (totalRequests > 1), generateAppendix_status: true,
                isInvoiceRecordUpdatedSuccessfully: true,
                totalRequests: (totalRequests - 1)
            }
        case invoicesConstants.generateAppendix_failure:
            if (collectiveErrorMsg_formatted != "") collectiveErrorMsg_formatted += "\n";
            
            if (action?.error?.response?.data?.exceptionMessage)
                collectiveErrorMsg_formatted += action?.error?.response?.data?.exceptionMessage;

            return {
                ...state,
                generateAppendix_requesting: (totalRequests > 1), generateAppendix_status: false,
                isInvoiceRecordUpdatedSuccessfully: false,
                generateAppendix_errorMsg: collectiveErrorMsg_formatted,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: (totalRequests - 1)
            }

        // Generate Invoice
        
        case invoicesConstants.generateInvoice_request:
            if (totalRequests == 0) 
                collectiveErrorMsg_formatted = "";

            return {
                ...state,
                generateInvoice_requesting: true, generateInvoice_status: false,
                isInvoiceRecordUpdatedSuccessfully: undefined,
                generateInvoice_errorMsg: undefined,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: (!(action?.details?.isRetrying))? (totalRequests + 1): totalRequests
            }
        case invoicesConstants.generateInvoice_success:
            return {
                ...state,
                generateInvoice_requesting: (totalRequests > 1), generateInvoice_status: true,
                isInvoiceRecordUpdatedSuccessfully: true,
                totalRequests: (totalRequests - 1)
            }
        case invoicesConstants.generateInvoice_failure:
            if (collectiveErrorMsg_formatted != "") collectiveErrorMsg_formatted += "\n";
            
            if (action?.error?.response?.data?.exceptionMessage)
                collectiveErrorMsg_formatted += action?.error?.response?.data?.exceptionMessage;

            return {
                ...state,
                generateInvoice_requesting: (totalRequests > 1), generateInvoice_status: false,
                isInvoiceRecordUpdatedSuccessfully: false,
                generateInvoice_errorMsg: collectiveErrorMsg_formatted,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: (totalRequests - 1)
            }

        // Post to SQL Account
        
        case invoicesConstants.postToSQLAccount_request:
            if (totalRequests == 0) 
                collectiveErrorMsg_formatted = "";

            return {
                ...state,
                postToSQLAccount_requesting: true, postToSQLAccount_status: false,
                isInvoiceRecordUpdatedSuccessfully: undefined,
                postToSQLAccount_errorMsg: undefined,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: (!(action?.details?.isRetrying))? (totalRequests + 1): totalRequests
            }
        case invoicesConstants.postToSQLAccount_success:
            return {
                ...state,
                postToSQLAccount_requesting: (totalRequests > 1), postToSQLAccount_status: true,
                isInvoiceRecordUpdatedSuccessfully: true,
                totalRequests: (totalRequests - 1)
            }
        case invoicesConstants.postToSQLAccount_failure:
            if (collectiveErrorMsg_formatted != "") collectiveErrorMsg_formatted += "\n";
            
            if (action?.error?.response?.data?.exceptionMessage)
                collectiveErrorMsg_formatted += action?.error?.response?.data?.exceptionMessage;

            return {
                ...state,
                postToSQLAccount_requesting: (totalRequests > 1), postToSQLAccount_status: false, 
                isInvoiceRecordUpdatedSuccessfully: false,
                postToSQLAccount_errorMsg: collectiveErrorMsg_formatted,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: (totalRequests - 1)
            }

        // Post to Credit Note
        
        case invoicesConstants.postCreditNote_request:
            if (totalRequests == 0) 
                collectiveErrorMsg_formatted = "";

            return {
                ...state,
                postCreditNote_requesting: true, postCreditNote_status: false,
                isInvoiceRecordUpdatedSuccessfully: undefined,
                postCreditNote_errorMsg: undefined,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: (!(action?.details?.isRetrying))? (totalRequests + 1): totalRequests
            }
        case invoicesConstants.postCreditNote_success:
            return {
                ...state,
                postCreditNote_requesting: (totalRequests > 1), postCreditNote_status: true,
                isInvoiceRecordUpdatedSuccessfully: true,
                totalRequests: (totalRequests - 1)
            }
        case invoicesConstants.postCreditNote_failure:
            if (collectiveErrorMsg_formatted != "") collectiveErrorMsg_formatted += "\n";
            
            if (action?.error?.response?.data?.exceptionMessage)
                collectiveErrorMsg_formatted += action?.error?.response?.data?.exceptionMessage;

            return {
                ...state,
                postCreditNote_requesting: (totalRequests > 1), postCreditNote_status: false, 
                isInvoiceRecordUpdatedSuccessfully: false,
                postCreditNote_errorMsg: collectiveErrorMsg_formatted,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: (totalRequests - 1)
            }

        // Send Email
        
        case invoicesConstants.sendEmail_request:
            if (totalRequests == 0) 
                collectiveErrorMsg_formatted = "";

            return {
                ...state,
                sendEmail_requesting: true, sendEmail_status: false,
                isInvoiceRecordUpdatedSuccessfully: undefined,
                sendEmail_errorMsg: undefined,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: (!(action?.details?.isRetrying))? (totalRequests + 1): totalRequests
            }
        case invoicesConstants.sendEmail_success:
            return {
                ...state,
                sendEmail_requesting: (totalRequests > 1), sendEmail_status: true,
                isInvoiceRecordUpdatedSuccessfully: true,
                totalRequests: (totalRequests - 1)
            }
        case invoicesConstants.sendEmail_failure:
            if (collectiveErrorMsg_formatted != "") collectiveErrorMsg_formatted += "\n";
            
            if (action?.error?.response?.data?.exceptionMessage)
                collectiveErrorMsg_formatted += action?.error?.response?.data?.exceptionMessage;

            return {
                ...state,
                sendEmail_requesting: (totalRequests > 1), sendEmail_status: false, 
                isInvoiceRecordUpdatedSuccessfully: false,
                sendEmail_errorMsg: collectiveErrorMsg_formatted,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: (totalRequests - 1)
            }

        // Delete Invoice
        
        case invoicesConstants.deleteInvoice_request:
            if (totalRequests == 0) 
            collectiveErrorMsg_formatted = "";
            
            return {
                ...state,
                deleteInvoice_requesting: true, deleteInvoice_status: false,
                isInvoiceRecordUpdatedSuccessfully: undefined,
                deleteInvoice_errorMsg: undefined,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: (!(action?.details?.isRetrying))? (totalRequests + 1): totalRequests
            }
        case invoicesConstants.deleteInvoice_success:
            return {
                ...state,
                deleteInvoice_requesting: (totalRequests > 1), deleteInvoice_status: true,
                isInvoiceRecordUpdatedSuccessfully: true,
                totalRequests: totalRequests - 1
            }
        case invoicesConstants.deleteInvoice_failure:
            if (collectiveErrorMsg_formatted != "") collectiveErrorMsg_formatted += "\n";
            
            if (action?.error?.response?.data?.exceptionMessage)
                collectiveErrorMsg_formatted += action?.error?.response?.data?.exceptionMessage;

            return {
                ...state,
                deleteInvoice_requesting: (totalRequests > 1), deleteInvoice_status: false, 
                isInvoiceRecordUpdatedSuccessfully: false,
                deleteInvoice_errorMsg: collectiveErrorMsg_formatted,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: totalRequests - 1
            }

        default:
            return state;
    }
}